import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取会员列表
export const getmembersList = params => {
    return get("/admin/members/applylist", params);
};
// 新增会员
export const addclassify = params => {
    return post("/admin/information/category", params);
};
// 修改会员信息
export const editmember = params => {
    return put(`/admin/members/aduit/${params.id}`, params);
};
// 删除会员
export const deleteclassify = params => {
    return del(`/admin/information/category/${params}`);
};

// 会员详情列表
export const getmembersListInfo = params => {
    return get("/admin/members", params);
};
// 获取单个会员详情
export const getmemberInfo = params => {
    // const memberForm = {
    //     xiaoqu_id: 4
    // }
    const paramsData = {
        xiaoqu_id: params.xiaoqu_id
    }
    return get(`/admin/members/detail/${params.id}`, paramsData);
};
// 修改会员权限
export const editmemberPower = params => {
    const id = params.id
    const paramsData = {
        xiaoqu_id: params.xiaoqu_id
    }
    return put(`/admin/members/setxiaoqu/${id}`, paramsData);
};
// 修改会员禁用启用权限
export const editmemberMake = params => {
    return put(`/admin/members/setstatus/${params.id}`);
};
// 修改模板消息状态
export const editmobanMake = params => {
    return put(`/admin/members/setTemplateStatus/${params.id}`);
};
export const editPhone = params => {
    const id = params.id
    const paramsData = {
        mobile: params.mobile
    }
    return put(`admin/members/edit/${params.id}`, paramsData);
};
export const editContent = params => {
    const id = params.id
    const paramsData = {
        content: params.content
    }
    return put(`admin/members/content/${params.id}`, paramsData);
};
// 修改姓名
export const editName = params => {
    const id = params.id
    const paramsData = {
        realname: params.realname
    }
    return put(`admin/members/name/${params.id}`, paramsData);
};
// 删除
export const deletePeople = params => {
    return del(`/admin/members/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/member.js